module.exports = __webpack_public_path__ + "img/illustration-missing-data.90468f87.svg";